import React, { Component } from 'react';
import queryString from 'query-string';
import { Button } from '../designSystem';
import { toast } from 'react-toastify';
import { withTranslation } from 'react-i18next';
import { FacebookShareButton, XShareButton, EmailShareButton } from 'react-share';
import uxAnalyticsUtil from '../../utils/uxAnalyticsUtil';
import copyToClipBoardUtil from '../../utils/copyToClipBoardUtil';

const shareButtonClass = 'br-button br-button--secondary br-button--small';

export class SharingWidget extends Component {
  state = { emailAddresses: '' };

  trackedUrl = (source) => {
    const { url, utmCampaign } = this.props;
    return `${url}?${queryString.stringify({
      utm_campaign: utmCampaign, utm_source: source, utm_medium: 'button',
    })}`;
  }

  copyURLToClipBoard = () => {
    const { url, t } = this.props;
    copyToClipBoardUtil.copyItemToClipBoard(this.trackedUrl('link'));
    toast.info(t('CopiedXToClipboard', { x: url }));
  }

  onClick = (source) => {
    uxAnalyticsUtil.trackEvent({
      category: 'Sharing',
      action: `clicked-${this.props.utmCampaign}`,
      label: source,
    });
  }

  copyLink = (source) => {
    this.onClick(source);
    this.copyURLToClipBoard();
  }

  sendEmailInvites = async () => {
    const { emailSharingEndpoint, emailSuccessMessage, emailSuccessMethod, idToken, t } = this.props;
    const { emailAddresses } = this.state;
    if (!emailAddresses) return;

    this.setState({ sendingEmails: true });
    try {
      const response = await fetch(emailSharingEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'br-token': idToken },
        body: JSON.stringify({ emails: emailAddresses }),
      });
      if (!response.ok) throw new Error(response.error || `HTTP ${response.status}`);
      const readerBonusList = await response.json();
      this.setState({ emailAddresses: '' });
      if (emailSuccessMessage) toast(emailSuccessMessage);
      if (emailSuccessMethod) emailSuccessMethod(readerBonusList);
    } catch (error) {
      console.error(error);
      uxAnalyticsUtil.trackException({ description: error.message, fatal: true });
      toast.error(t('SomethingWentWrong'));
    } finally {
      this.setState({ sendingEmails: false });
    }
  }

  render() {
    const { url, message, body, shareTo, hashtags, header, infoText, disabled, t } = this.props;
    const { emailAddresses, sendingEmails } = this.state;
    if (!url || !shareTo) return null;

    return (
      <section className='br-share'>
        {header && <h2>{header}</h2>}
        <div className='br-share__actions'>
          {shareTo.includes('facebook') &&
            <FacebookShareButton type='button' url={this.trackedUrl('facebook')}
              hashtag='#betareaders' className={shareButtonClass}
              resetButtonStyle={false} beforeOnClick={() => this.onClick('facebook')}
              disabled={!!disabled}>Facebook</FacebookShareButton>}
          {shareTo.includes('twitter') &&
            <XShareButton type='button' url={this.trackedUrl('twitter')}
              text={message} via='betareaderapp' hashtags={hashtags}
              className={shareButtonClass} resetButtonStyle={false}
              beforeOnClick={() => this.onClick('twitter')}
              disabled={!!disabled}>X</XShareButton>}
          {shareTo.includes('email') &&
            <EmailShareButton type='button' url={this.trackedUrl('email')}
              subject={message} body={body} className={shareButtonClass}
              resetButtonStyle={false} beforeOnClick={() => this.onClick('email')}
              disabled={!!disabled}>Email</EmailShareButton>}
          {shareTo.includes('clipboard') &&
            <Button variant='secondary' size='small' disabled={!!disabled}
              onClick={() => this.copyLink('clipboard')}>Copy link</Button>}
        </div>
        {shareTo.includes('copy') &&
          <div className='br-share__copy'>
            <label className='br-share__field'>Share link
              <input readOnly value={url} />
            </label>
            <Button variant='secondary' size='small' disabled={!!disabled}
              onClick={() => this.copyLink('copy')}>Copy</Button>
          </div>}
        {shareTo.includes('email-address') &&
          <form className='br-share__copy' onSubmit={(event) => {
            event.preventDefault();
            this.onClick('send-email');
            this.sendEmailInvites();
          }}>
            <label className='br-share__field'>{t('Email')}
              <input type='text' inputMode='email' value={emailAddresses} disabled={sendingEmails}
                onChange={(event) => this.setState({ emailAddresses: event.target.value })} />
            </label>
            <Button variant='secondary' size='small' type='submit'
              disabled={!!disabled || !!sendingEmails}>Send</Button>
          </form>}
        {infoText && <p className='br-share__info'>{infoText}</p>}
      </section>
    );
  }
}

export default withTranslation()(SharingWidget);
